import { Container } from "react-bootstrap";
import { API_BASE_URL } from "configs/AppConfig";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import MainButton from "component/shared/mainButton/MainButton";

export default function PhotosTab({ photos }) {
  return (
    <Container
      style={{ backgroundColor: "#EBEBEB" }}
      className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
    >
      <div>
        {photos && Object.keys(photos).length > 0 ? (
          <div className="row gx-md-3 gy-3 gy-md-0">
            <div className="col-12 col-md-6">
              <img
                src={
                  photos[0]?.thumbnail
                    ? `${API_BASE_URL}/${photos[0]?.thumbnail}`
                    : process.env.PUBLIC_URL + "/image/news1.png"
                }
                alt="arrow"
                loading="lazy"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className="col-12 col-md-6">
              <div className="row gx-md-3 gy-3">
                {photos
                  .map(({ thumbnail }, i) => (
                    <div key={i} className="col-12 col-md-6">
                      <img
                        src={
                          thumbnail
                            ? `${API_BASE_URL}/${thumbnail}`
                            : process.env.PUBLIC_URL + "/image/news1.png"
                        }
                        alt="arrow"
                        loading="lazy"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  ))
                  .slice(1, 5)}
              </div>
            </div>
          </div>
        ) : (
          <DataNotFound />
        )}

        <div className="row">
          <label>
            <br />
          </label>
          <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
          <div className="col-xl-3 col-lg-4 col-md-3 col-sm-6 col-12">
            <MainButton
              link={"mediaLanding/media#albums"}
              text={"all-images"}
            />
          </div>
        </div>
      </div>
    </Container>
  );
}
